import React from 'react';
import './MembershipPage.css';

const MembershipBenefits = () => {
  const benefits = [
    {
      id: 1,
      title: "AI-Powered School Management",
      description: "Streamline administrative tasks with our AI-powered school management system designed specifically for Islamic schools",
      icon: "📊"
    },
    {
      id: 2,
      title: "Teacher Training",
      description: "Comprehensive training sessions for teachers on how to ethically use AI tools in the classroom while maintaining Islamic values",
      icon: "👨‍🏫"
    },
    {
      id: 3,
      title: "AI Implementation Consultation",
      description: "Personalized consultation on implementing AI solutions that fit your school's unique needs and challenges",
      icon: "💼"
    },
    {
      id: 4,
      title: "Student Privacy Protection",
      description: "Ensure student data is protected with our privacy-focused AI solutions that comply with educational standards",
      icon: "🔒"
    },
    {
      id: 5,
      title: "Customized AI Content",
      description: "Access to AI-generated content that's tailored for Islamic education, from lesson plans to educational materials",
      icon: "📚"
    },
    {
      id: 6,
      title: "Continuous Updates",
      description: "Stay ahead with regular updates on the latest AI developments relevant to Islamic education through our monthly newsletter",
      icon: "🔄"
    }
  ];

  return (
    <div className="benefits-container">
      <h2>Why Join Nur Al Huda Member Schools?</h2>
      <div className="benefits-grid">
        {benefits.map(benefit => (
          <div key={benefit.id} className="benefit-card">
            <div className="benefit-icon">{benefit.icon}</div>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MembershipBenefits; 